export type StaticRoute = {
  routeId: number;
  circuitId: number;
  name: string;
  circuitName: string;
  sortKey: number;
};

export const STATIC_ROUTES: StaticRoute[] = [
  { routeId: 7, circuitId: 1, name: "Route 1-A: Machupicchu Mountain", circuitName: "Circuit 1", sortKey: 7 },
  { routeId: 8, circuitId: 1, name: "Route 1-B: Upper terrace", circuitName: "Circuit 1", sortKey: 8 },
  { routeId: 9, circuitId: 1, name: "Route 1-C: Intipunku", circuitName: "Circuit 1", sortKey: 9 },
  { routeId: 10, circuitId: 1, name: "Route 1-D: Inka Bridge", circuitName: "Circuit 1", sortKey: 10 },
  { routeId: 11, circuitId: 2, name: "Route 2-A: Classic designed route", circuitName: "Circuit 2", sortKey: 11 },
  { routeId: 12, circuitId: 2, name: "Route 2-B: Lower terrace", circuitName: "Circuit 2", sortKey: 12 },
  { routeId: 13, circuitId: 3, name: "Route 3-A: Huayna Picchu Mountain", circuitName: "Circuit 3", sortKey: 13 },
  { routeId: 14, circuitId: 3, name: "Route 3-B: Royalty route", circuitName: "Circuit 3", sortKey: 14 },
  { routeId: 15, circuitId: 3, name: "Route 3-C: Great cavern", circuitName: "Circuit 3", sortKey: 15 },
  { routeId: 16, circuitId: 3, name: "Route 3-D: Huchuy Picchu", circuitName: "Circuit 3", sortKey: 16 },
];
